// import React from "react";

// export default function Navbar() {
//     return (
//       <nav className="bg-gray-800 p-4">
//         <div className="container mx-auto">
//           <div className="flex justify-center">
//             <h1 className="text-white text-xl font-semibold">
//               Restaurant Management Optimizer
//             </h1>
//           </div>
//         </div>
//       </nav>
//     );
//   }
  
import React from "react";

export default function Navbar() {
  return (
    <nav className="bg-gray-800 p-4">
      <div className="container mx-auto">
        <div className="flex justify-center">
          <h1 className="text-white text-2xl font-bold" style={{ fontFamily: 'Poppins, sans-serif' }}>
            Restaurant Management Optimizer
          </h1>
        </div>
      </div>
    </nav>
  );
}
